/**
 * El botón que muestra el PDF de una liquidación en el visor, desde donde se
 * descarga. Lo usan el listado de liquidaciones y el inicio del portal: el
 * cliente sale del caso de autenticación.
 */
import { Eye } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import apiClient from '@/lib/apiClient'
import { portalApiClient } from '@/store/portalAuthStore'
import { useVisorPdf } from '@/components/VisorPdf'

export function VerLiquidacion({ payslipId, periodLabel }: { payslipId: string; periodLabel: string }) {
  const { pathname } = useLocation()
  const client = pathname.startsWith('/colaboradores') ? portalApiClient : apiClient
  const { ver, visor } = useVisorPdf()
  const abrir = () => ver({
    titulo: `Liquidación ${periodLabel}`,
    nombreArchivo: `liquidacion_${periodLabel.replace(/\s+/g, '_')}.pdf`,
    cargar: async () =>
      (await client.get(`/employee/payslips/${payslipId}/pdf/`, { responseType: 'blob' })).data,
  })
  return (
    <>
      <button
        onClick={abrir}
        className="inline-flex items-center gap-1 text-xs text-primary hover:underline"
        aria-label={`Ver la liquidación ${periodLabel}`}
      >
        <Eye size={13} aria-hidden="true" />
        Ver PDF
      </button>
      {visor}
    </>
  )
}
